import React from 'react';
import PropTypes from 'prop-types';

import { Helpers } from '../../core/src/helpers';
import Icon from '../../ui/components/icon';

import './compare-box.less';

function CompareBox({ product, toggleCompareProduct, readOnly }) {
    // TODO: temp fix for product inconsistency between APIs clean up props (name, )
    const { title, images, price, imageUrl, name, salePrice } = product;

    // TODO: i think there is a bug where product drops images and only has imageUrl src and not an image object, cant find how replicate exactly
    // INFO: the product object is a bit different when comparing as the main product of the page vs other products such as the on on similar products list
    // gonna reverse the logic to take imageUrl first if it exists
    const firstImage = (imageUrl && { src: imageUrl }) || (images && images[0]);

    return (
        <div className="compare-box item">
            <div className="headerClose">
                <span className="action" onClick={() => toggleCompareProduct(product)}>
                    <Icon name="x" size={16} />
                </span>
            </div>
            <div className="product">
                <div className="product-container">
                    <div className="imageSpacing" />
                    <div className="imageContainer">
                        <img src={firstImage?.src} alt="product" />
                    </div>
                    <div className="imageSpacing">
                        {!readOnly && (
                            <div className="action" onClick={() => toggleCompareProduct(product)}>
                                <Icon name="x" size={16} />
                            </div>
                        )}
                    </div>
                </div>
                <div className="name" style={{ WebkitBoxOrient: 'vertical' }}>
                    {title || name}
                </div>
            </div>
            <div className="price">{Helpers.formatCurrency(price?.salePrice || salePrice, '$')}</div>
        </div>
    );
}

CompareBox.propsTypes = {
    /** product object */
    product: PropTypes.object,
    /** add/remove product from compare set */
    toggleCompareProduct: PropTypes.func,
};

export default CompareBox;
